import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { isObjectEmpty } from './object'
import type { NextRequest } from 'next/server'

const request = async (
  url: string,
  options: AxiosRequestConfig = { withCredentials: true },
  autoParse = true
) => {
  try {
    const response: AxiosResponse = await axios(url, options)

    if (response.status >= 200 && response.status < 300) {
      if (!autoParse) {
        return response
      }

      const data = response.data
      if (data.redirect) {
        window.location.href = data.redirect
      }

      return data
    }
  } catch (error) {
    const axiosError = error as AxiosError
    if (options.method === 'HEAD') {
      throw new Error(axiosError.response?.status.toString())
    }

    const errorData = axiosError.response?.data
    if (isObjectEmpty(errorData)) {
      throw new Error(
        `Unexpected error while fetching with ${url} with options ${JSON.stringify(
          options,
          null,
          2
        )}`
      )
    }

    throw errorData
  }
}

export const makeHeaders = (req: NextRequest) => ({
  Cookie: req.cookies.toString(),
  'User-Agent': req.headers.get('User-Agent') as string,
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-Forwarded-For': req.headers.get('X-Forwarded-For') as string,
  // Custom header for OMS to identify the caller page URL
  // There is no standard header that fit our use case: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers
  ...(req.headers.get('Loaded-Url')
    ? {
        'Loaded-Url': req.headers.get('Loaded-Url') as string,
      }
    : {}),
  ...(req.headers.get('Referer')
    ? {
        Referer: req.headers.get('Referer') as string,
      }
    : {}),
})

export default request
